import React from "react";

export const RadioButtonVariantSet = () => {
    throw "Component Version Mismatch: You cannot use this config with this version of the app.";
};

export default RadioButtonVariantSet;